import React, { Component } from 'react';

import './styles.css'


class BusSeatNew extends Component {
  render(){
    let seatLabel, Seat, baseFare;
    const { seat, onClick, fareSelected, selectedSeats, state, selectSeatHandler } = this.props;
    let seatNumberString, isSelected;
    if(seat){
      baseFare = seat.baseFare;
      seatNumberString = seat.seat_number || seat.seat_no || seat.seat_name;
      seatNumberString = seatNumberString.toString().substring(0,3);
      seatNumberString = <div className='black9p centerMove'>{seatNumberString}</div>;
      isSelected = selectedSeats.includes(JSON.stringify(seat));
    }

    if(!seat)
      Seat = <div className='alignCenter'><div className='normalSeat notVisible'></div></div>;


    //seater
    else if(seat && seat.length === 1 && seat.width === 1){
      Seat = <div className='alignCenter' onClick={() => selectSeatHandler(seat)}><div className={`normalSeat 
      ${seat.is_reserved_for_ladies && seat.is_available ? 'reservedLadies' : ''} 
      ${!seat.is_reserved_for_ladies && !seat.is_available ? 'disabled' : ''} 
      ${seat.is_reserved_for_ladies && !seat.is_available ? 'bookedLadies' : ''} 
      ${isSelected ? 'selected' : ''}`}>
        {seatNumberString}
        <span className='upperBox icons' />
        <span className='lowerBox icons' />
        <span className='backBox icons' />
      </div></div>
    }

    //sleeper
    else if(seat && seat.length === 2 && seat.width === 1) {
      Seat = <div className='alignCenter' onClick={() => selectSeatHandler(seat)}><div className={`sleeperSeat 
      ${seat.is_reserved_for_ladies ? 'reservedLadies' : ''} 
      ${!seat.is_reserved_for_ladies && !seat.is_available ? 'disabled' : ''} 
      ${seat.is_reserved_for_ladies && !seat.is_available ? 'bookedLadies' : ''} 
      ${isSelected ? 'selected' : ''}`}
      >
      {seatNumberString}<span /></div></div>
    }


    //rotated sleeper
    else if(seat && seat.length === 1 && seat.width === 2) {
      Seat = <div className='alignCenter' onClick={() => selectSeatHandler(seat)}><div className={`rotatedSleeper 
      ${seat.is_reserved_for_ladies ? 'reservedLadies' : ''}
      ${!seat.is_reserved_for_ladies && !seat.is_available ? 'disabled' : ''} 
      ${seat.is_reserved_for_ladies && !seat.is_available ? 'bookedLadies' : ''} 
      ${isSelected ? 'selected' : ''}`}>
        {seatNumberString}
        <span />
      </div></div>
    }

    return Seat;
  }
}


export default BusSeatNew;
